import { createAction, props } from '@ngrx/store';
import { SmartDocumentUploadFileData } from 'src/app/shared/constants-and-enums/smart-document-upload-types';
import { CompanyMode } from '../../shared/constants-and-enums/company-mode.enum';

export const InitSmartDocumentUpload = createAction('[SmartDocumentUpload] InitSmartDocumentUpload');
export const ResetSmartDocumentUpload = createAction('[SmartDocumentUpload] ResetSmartDocumentUpload');

export const SmartDocumentUploadSubmit = createAction(
    '[SmartDocumentUpload] SmartDocumentUploadSubmit',
    props<{ hwpId?: string; mode: CompanyMode; entityId: string; businessPartnerNumber: string }>()
);
export const SmartDocumentUploadAddFile = createAction(
    '[SmartDocumentUpload] SmartDocumentUploadAddFile',
    props<{ fileData: SmartDocumentUploadFileData }>()
);

export const SmartDocumentUploadSuccess = createAction(
    '[SmartDocumentUpload] SmartDocumentUploadSuccess',
    props<{ numberOfUploadedDocuments?: number }>()
);
export const SmartDocumentUploadFailure = createAction('[SmartDocumentUpload] SmartDocumentUploadFailure', props<{ error?: any }>());
